import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getAllTest } from '../../redux/GetAllTestSlice';
import { homeData } from '../../redux/HomeSlice';
import { Helmet } from 'react-helmet-async';

const Package = () => {
    const dispatch = useDispatch();

    const responseHome = useSelector((state) => state.homeReducer.data);
    const allTestResponse = useSelector((state) => state.getAllTestReducer.data);

    const [allTest, setAllTest] = useState([]);
    const [homeData2, setHomeData] = useState(null);

    const [selectedIndex,setSelectedIndex] = useState(0)

    useEffect(() => {
        dispatch(homeData());       
    }, []);

    useEffect(() => {
        if (responseHome?.status === 1) {
            setHomeData(responseHome.data);
            dispatch(getAllTest(responseHome.data?.categories[0]?._id));
        }
    }, [responseHome]);

    useEffect(() => {
        console.log("allTestResponse ====> ",allTestResponse)
        if (allTestResponse?.status === 1) {
            setAllTest(allTestResponse.data);
        }
    }, [allTestResponse]);


    const clickOnCategory = (index,categoryId) => {
        setSelectedIndex(index);
        console.log("category Id ===> ",categoryId)
        dispatch(getAllTest(categoryId));
    }
    

    return (
        <>
            <Helmet>
                <title>
                    Preventive Health Packages in Mohali | Affordable Diagnostic Packages
                </title>
                <meta
                    name="description"
                    content="Explore modern preventive health packages in Mohali including lab tests, imaging, X-ray, ultrasound and annual health checkups."
                />
            </Helmet>

            <div className="package">
                {/* HERO */}
                <div className="package_hero">
                    <h1>Preventive Health Tests</h1>
                    <p>Early detection. Smart diagnostics. Better care.</p>
                </div>

                <div className="coustom_container">
                    <Row className="package_layout">
                        {/* SIDEBAR */}
                        <Col lg={3} md={4} sm={12}>
                            <div className="package_sidebar">
                                <div className="sidebar_header">
                                    <span className="icon">🧪</span>
                                    <h5>Categories</h5>
                                </div>

                                <ul className="category_list">
                                    {homeData2?.categories?.map((item, index) => (
                                        <li  key={item.id} className={index === selectedIndex ? 'active' : ''} onClick={()=>clickOnCategory(index, item._id)}>
                                            <span className="dot"></span>
                                            {item.name}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>

                        {/* CONTENT */}
                        <Col lg={9} md={8} sm={12}>
                            <div className="package_content">
                                {/* <h4>Lab Test Packages</h4> */}

                                <Row>
                                    {allTest.map((item) => (
                                        <Col lg={4} md={6} sm={12} key={item.id}>
                                            <Card className="package_card">
                                                <Card.Body>
                                                    {/* <span className="badge">Lab Test</span> */}

                                                    <h6 className="title">{item.name}</h6>

                                                    {/* <p className="meta">
                                                        ✓ 20 Parameters Included
                                                    </p> */}

                                                    <div className="price">
                                                        ₹ {item.amount}
                                                    </div>

                                                    <div className="actions">
                                                        <a
                                                            href="https://play.google.com/store/search?q=kior+healthcare&c=apps"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="btn_primary"
                                                        >
                                                            Add to Cart
                                                        </a>

                                                        <a
                                                            href="https://play.google.com/store/search?q=kior+healthcare&c=apps"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="btn_link"
                                                        >
                                                            Know More →
                                                        </a>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default Package;
